/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable no-unused-vars */
import React from 'react';
import type { I18nLike } from '@bingads-webui/common-types';
import { PropsWithDefaultStyle } from '@bingads-webui-react/with-default-styles';

declare const window: {
  PopupController?: {
    PopupJsClick: (target: EventTarget | null) => void;
  };
};

interface IHelpPopupProps {
  'aria-label'?: string | null;
  'aria-labelledby'?: string | null;
  topic: string;
  i18n?: Pick<I18nLike, 'getString'> | null;
}

/**
 * @param {MouseEvent} event click event
 * @return {void}
 */
function onClick(event: React.MouseEvent<HTMLAnchorElement>): void {
  event.preventDefault();
  event.stopPropagation();
  if (!window.PopupController) {
    return;
  }
  window.PopupController.PopupJsClick(event.target);
}

export function HelpPopup(props: PropsWithDefaultStyle<IHelpPopupProps>) {
  return (
    <a
      aria-label={props['aria-label']}
      aria-labelledby={props['aria-labelledby']}
      className="helpbutton"
      href="#"
      onClick={onClick}
      topic={props.topic}
      type="helppopup"
      role="button"
      aria-roledescription={props.i18n?.getString(_TL_('info button'))}
    />
  );
}

HelpPopup.defaultProps = {
  'aria-label': null,
  'aria-labelledby': null,
  i18n: null,
};
